export const VERTICAL = '6120350289';
export const HORIZONTAL = '1881722374';
export const SQUARE = '4507885718';
// export const VERTICAL = '4749018709';
// export const HORIZONTAL = '1548140298';
// export const SQUARE = '4507885718';
